<!-- Séquençage V2 — Warmer Froala hors écran : monte une instance unique dès l'arrivée
     sur le composant pour pré-charger les assets Froala (toolbar, CSS, JS). Les expansions
     suivantes de l'accordion bénéficient du cache et n'entraînent plus de reflow visible. -->
<div class="froala-warmer" aria-hidden="true">
  <app-froala-editor></app-froala-editor>
</div>

@if (loading) {
  <!-- Aligné sur le loader habituel des autres slides du funnel (cf. document-verification +
       document-compliance) : <pr-loader> centré + message texte sous-jacent. -->
  <div style="max-height: none; margin-top: 1rem; position: relative">
    <pr-loader style="max-height: 0rem; margin-top: 7rem"></pr-loader>
    <p class="loader-documents-message">{{ loadingMessage }}</p>
  </div>
} @else if (internalError) {
  <info [option]="'error'">{{ internalError }}</info>
} @else if (sections.length === 0) {
  <info>Aucun document à signer pour cette souscription.</info>
} @else {
  @for (section of sections; track section.packType) {
    <section class="pack-section">
      <h3 class="pack-title">{{ section.title }}</h3>

      @for (row of section.rows; track row.packDocumentId) {
        <article class="doc-row" [class.reusable]="row.isReusable" [class.expanded]="row.expanded">
          <div class="doc-header" (click)="toggleExpand(row)">
            <span class="doc-toggle" aria-hidden="true">{{ row.expanded ? '−' : '+' }}</span>
            <span class="doc-label">{{ row.label }}</span>
            @if (row.isReusable) {
              <span class="badge badge-reusable">Réutilisable</span>
            } @else {
              <span class="badge badge-new">À générer</span>
            }
            @if (row.optional) {
              <!-- Bouton pour retirer un doc optionnel (par ex. Convention RTO).
                   Icône Material delete_outline + style circulaire moderne (cf. SCSS .doc-remove).
                   Stop propagation pour ne pas déclencher toggleExpand au clic. -->
              <button
                type="button"
                class="doc-remove"
                matTooltip="Retirer ce document optionnel"
                aria-label="Retirer ce document optionnel"
                (click)="$event.stopPropagation(); onRemoveOptionalClick(section, row)"
              >
                <mat-icon>delete_outline</mat-icon>
              </button>
            }
          </div>

          @if (row.expanded) {
          <div class="doc-body">
            @if (row.isReusable) {
              <!-- Bug B — différencier le wording selon que le doc source est déjà signé
                   (signedAt non null) ou encore en attente de signature (pack source en
                   WAITING_SIGNATURE). isReusable seul n'implique pas la signature. -->
              @if (row.signedAt) {
                <div class="doc-meta">
                  Un {{ row.label.toLowerCase() }} signé le {{ row.signedAt | date: 'dd/MM/yyyy' }}
                  pour ce profil investisseur est disponible.
                </div>
              } @else {
                <div class="doc-meta">
                  Un {{ row.label.toLowerCase() }} pour ce profil investisseur est en attente
                  de signature et sera réutilisé une fois signé.
                </div>
              }
              <div class="reuse-choice">
                <label class="reuse-option">
                  <input
                    type="radio"
                    [name]="'doc-' + row.packDocumentId"
                    [checked]="!row.regenerate"
                    (change)="onKeepClick(row)"
                  />
                  <span>Réutiliser</span>
                </label>
                <label class="reuse-option">
                  <input
                    type="radio"
                    [name]="'doc-' + row.packDocumentId"
                    [checked]="row.regenerate"
                    (change)="onRegenerateClick(row)"
                  />
                  <span>Regénérer</span>
                </label>
              </div>
            } @else if (row.fragments != null) {
              <!-- Séquençage V2 (parité legacy modernisée) — un panneau d'édition par
                   fragment du document (couverture, contenu, signature). Le contenu principal est
                   ouvert d'office ; les autres parties se déplient en un clic. -->
              @if (row.fragments.length === 1) {
                <div class="doc-meta">Modifiez le contenu ci-dessous si nécessaire.</div>
                <app-froala-editor
                  [(ngModel)]="row.fragments[0].html"
                  [toolbarButtons]="toolbarButtons"
                ></app-froala-editor>
              } @else {
                <div class="doc-meta">
                  Ce document est composé de {{ row.fragments.length }} parties — chacune est
                  modifiable si nécessaire.
                </div>
                <div class="fragment-list">
                  @for (fragment of row.fragments; track $index) {
                    <div class="fragment-card" [class.expanded]="fragment.expanded">
                      <div class="fragment-header" (click)="toggleFragment(fragment)">
                        <span class="fragment-step">{{ $index + 1 }}</span>
                        <span class="fragment-label">{{ fragment.label }}</span>
                        <span class="fragment-action">{{ fragment.expanded ? 'Replier' : 'Modifier' }}</span>
                      </div>
                      @if (fragment.expanded) {
                        <div class="fragment-body">
                          <app-froala-editor
                            [(ngModel)]="fragment.html"
                            [toolbarButtons]="toolbarButtons"
                          ></app-froala-editor>
                        </div>
                      }
                    </div>
                  }
                </div>
              }
            } @else if (row.gedDocumentId != null) {
              <!-- Pack BS : PDF pré-généré au funnel par
                   PackBsBuildingService, on l'affiche inline en lecture (pas d'édition).
                   Lazy load au premier dépliage (cf. toggleExpand → loadPdfPreview). -->
              @if (row.pdfSafeUrl) {
                <iframe [src]="row.pdfSafeUrl" width="100%" height="600" frameborder="0"></iframe>
              } @else if (row.loadingPdf) {
                <pr-spinner></pr-spinner>
              } @else if (row.pdfError) {
                <div class="doc-meta">Erreur lors du chargement du PDF.</div>
              }
            } @else {
              <div class="doc-meta">Ce document sera généré et signé.</div>
            }
          </div>
          }
        </article>
      }
    </section>
  }
}
<!-- /sections -->


<div class="btn-group">
  <pr-button
    size="lg"
    type="button"
    label="Question précédente"
    icon="arrow_left"
    [disabled]="loading"
    (onClick)="onPrev()"
  ></pr-button>
  <pr-button
    size="lg"
    type="button"
    display="neutral"
    label="Continuer"
    [disabled]="loading || !!internalError"
    (onClick)="onConfirm()"
  ></pr-button>
</div>
